/* eslint-disable no-param-reassign */
import "@formatjs/intl-locale/polyfill";
import "@formatjs/intl-numberformat/polyfill";
import "@formatjs/intl-numberformat/locale-data/en";
import "@formatjs/intl-numberformat/locale-data/de";
import { isObject } from "lodash-es";

import { locale } from "./browserUtils";

export function numberFormat() {
  return new Intl.NumberFormat(locale());
}

export function formatNumber(number: $TSFixMe) {
  return numberFormat().format(number);
}

export function numberFormatter(options: $TSFixMe) {
  return new Intl.NumberFormat(locale(), options);
}

export function isSomething(value: $TSFixMe) {
  return value !== null && value !== undefined;
}

export function isNothing(value: $TSFixMe) {
  return !isSomething(value);
}

export function isNumber(value: $TSFixMe) {
  return (
    value !== null &&
    value !== undefined &&
    (typeof value === "number" || value instanceof Number)
  );
}

export function isString(value: $TSFixMe) {
  return (
    value !== null &&
    value !== undefined &&
    (typeof value === "string" || value instanceof String)
  );
}

export function isArray(value: $TSFixMe) {
  return (
    value !== null &&
    value !== undefined &&
    (value instanceof Array || Array.isArray(value))
  );
}

export function isNotEmpty(value: $TSFixMe) {
  return (isString(value) || isArray(value)) && value.length > 0;
}

export function isNullOrEmpty(value: $TSFixMe) {
  return !value || !value.trim();
}

export function isEmpty(value: $TSFixMe) {
  return !isNotEmpty(value);
}

export function isFunction(value: $TSFixMe) {
  return !!(value && value.constructor && value.call && value.apply);
}

export function camel(value: $TSFixMe) {
  return value.replace(/[-_]([a-z])/g, (g: $TSFixMe) => g[1].toUpperCase());
}

export function random(min: $TSFixMe, max: $TSFixMe) {
  return (
    Math.floor(Math.random() * (Math.floor(max) - Math.ceil(min) + 1)) + // NOSONAR - this is not used in cryptographic context but only to generate random tenant names
    Math.ceil(min)
  );
}

export function isValidEmail(email: $TSFixMe) {
  /* eslint-disable no-useless-escape */
  // https://emailregex.com/#crayon-5c5b38b704153632751579
  const reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!reg.test(email)) return false;
  return true;
}

const inRange = (min: $TSFixMe, number: $TSFixMe, max: $TSFixMe) =>
  isNumber(number) && number >= min && number <= max;

export function isValidCoordinates(numberLat: $TSFixMe, numberLng: $TSFixMe) {
  return (
    inRange(-90, Number(numberLat), 90) && inRange(-180, Number(numberLng), 180)
  );
}

export function isObjectNullOrUndefined(object: $TSFixMe) {
  return object == null;
}

export function extractFirstIdFromIdArray(idArray: $TSFixMe) {
  if (/^[0-9][0-9,]*$/.test(idArray)) {
    return idArray.split(",")[0];
  }
  return null;
}

export function convertIdsArrayToHirarchicalIdsArray(idsArray: $TSFixMe) {
  if (/^[0-9][0-9,]*$/.test(idsArray)) {
    return `${idsArray.split(",").join("+,")}+`;
  }
  return null;
}

export function singularPlural(count: $TSFixMe) {
  return count === 1 ? "singular" : "plural";
}

export function formatTime(seconds: $TSFixMe) {
  if (seconds >= 0) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return [h, m > 9 ? m : `0${m}`, s > 9 ? s : `0${s}`]
      .filter((se) => se)
      .join(":");
  }
  return "";
}

export function parseDecimal(value: $TSFixMe) {
  return isSomething(value) ? parseFloat(value) : undefined;
}

export function convertBytesToGB(storage: $TSFixMe, digits = 2) {
  return (storage / 1024 / 1024 / 1024).toFixed(digits);
}

export function equalsByAttribute(
  a: $TSFixMe,
  b: $TSFixMe,
  attribute: $TSFixMe,
) {
  if (!a && !b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return a[attribute] === b[attribute];
}

export function prettifyIpAddress(ip: $TSFixMe) {
  return ip
    .split(".")
    .map((t: $TSFixMe) => parseInt(t, 10))
    .join(".");
}

export function concatValues(values: $TSFixMe, separator: $TSFixMe) {
  return values
    .filter((a: $TSFixMe) => a)
    .join(separator)
    .trim();
}

export function firstToUpperCase(string: $TSFixMe) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function firstToLowerCase(string: $TSFixMe) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export function prefixObjectKeys(object: $TSFixMe, prefix: $TSFixMe) {
  if (isEmpty(prefix) || isNothing(object)) {
    return object;
  }
  const prefixedObject = {};
  Object.keys(object).forEach((key) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    prefixedObject[`${prefix}${firstToUpperCase(key)}`] = object[key];
  });
  return prefixedObject;
}

export function unprefixObjectKeys(prefixedObject: $TSFixMe, prefix: $TSFixMe) {
  if (isEmpty(prefix) || isNothing(prefixedObject)) {
    return prefixedObject;
  }
  const object = {};
  Object.keys(prefixedObject).forEach((key) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    object[firstToLowerCase(key.slice(prefix.length))] = prefixedObject[key];
  });
  return object;
}

export function capitalizeFirstLetter(string: $TSFixMe) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function capitalizeWords(str: $TSFixMe) {
  return str
    ? str.replace(/\w+/g, (m: $TSFixMe) => capitalizeFirstLetter(m))
    : "";
}

export function humanize(str: $TSFixMe, capitalize = true) {
  let result = str;

  if (result) {
    result = result
      .replace(/[_\s]+/g, " ")
      .replace(/[.\s]+/g, " ")
      .replace(/[-\s]+/g, " ")
      .replace(/[a-z][A-Z]/g, (s: $TSFixMe) => `${s[0]} ${s[1].toLowerCase()}`)
      .trim();

    if (capitalize) {
      result = capitalizeFirstLetter(result);
    }

    return result;
  }

  return "";
}

export function concatObjectValues(object: $TSFixMe, separator = ",") {
  return concatValues(
    Object.keys(object).map((key) => object[key]),
    separator,
  );
}

export function sortBy(
  objectsArray: $TSFixMe,
  attribute: $TSFixMe,
  direction?: $TSFixMe,
) {
  let clone = objectsArray.slice(0);
  clone = clone.sort((a: $TSFixMe, b: $TSFixMe) => {
    const sortDirection = direction === "ASC" ? -1 : 1; // -1 = ASCENDING, 1 = DESCENDING

    if (
      isNothing(a[attribute]) ||
      (isEmpty(a[attribute]) && typeof a[attribute] === "string")
    ) {
      return -1 * sortDirection;
    }
    if (
      isNothing(b[attribute]) ||
      (isEmpty(b[attribute]) && typeof b[attribute] === "string")
    ) {
      return 1 * sortDirection;
    }

    const attributeType = typeof a[attribute];
    let compareValue = 0;

    if (attributeType === "boolean" || attributeType === "number") {
      compareValue = (a[attribute] - b[attribute]) * -1;
    } else {
      compareValue = a[attribute]
        .toString()
        .localeCompare(b[attribute].toString());
    }
    return compareValue * sortDirection;
  });
  return clone;
}

export function sortByNestedAttribute(
  array: $TSFixMe,
  direction: $TSFixMe,
  nestedAttributes = [],
) {
  if (array.length === 0) {
    return [];
  }
  let clone = array.slice(0);

  const getObjectAttribute = (object: $TSFixMe, attributeArray: $TSFixMe) => {
    let nestedObject = object;
    for (let i = 0; i <= attributeArray.length - 1; i += 1) {
      if (
        nestedObject &&
        // @ts-expect-error TS(2304) FIXME: Cannot find name 'hasOwnProperty'.
        hasOwnProperty.call(nestedObject, attributeArray[i])
      ) {
        nestedObject = nestedObject[attributeArray[i]];
      } else {
        nestedObject = undefined;
        break;
      }
    }
    return nestedObject;
  };

  if (nestedAttributes.length > 1) {
    clone = clone.sort((a: $TSFixMe, b: $TSFixMe) => {
      const sortDirection = direction === "ASC" ? -1 : 1; // -1 = ASCENDING, 1 = DESCENDING
      const aAttribute = getObjectAttribute(a, nestedAttributes);
      const bAttribute = getObjectAttribute(b, nestedAttributes);

      if (
        isNothing(aAttribute) ||
        (isEmpty(aAttribute) && typeof aAttribute === "string")
      ) {
        return -1 * sortDirection;
      }
      if (
        isNothing(bAttribute) ||
        (isEmpty(bAttribute) && typeof bAttribute === "string")
      ) {
        return 1 * sortDirection;
      }

      const attributeType = typeof getObjectAttribute(a, nestedAttributes);
      let compareValue = 0;

      if (attributeType === "boolean" || attributeType === "number") {
        compareValue =
          (getObjectAttribute(a, nestedAttributes) -
            getObjectAttribute(b, nestedAttributes)) *
          -1;
      } else {
        compareValue = getObjectAttribute(a, nestedAttributes)
          .toString()
          .localeCompare(getObjectAttribute(b, nestedAttributes).toString());
      }
      return compareValue * sortDirection;
    });
  }
  return clone;
}

export async function asyncForEach(array: $TSFixMe, callback: $TSFixMe) {
  for (let index = 0; index < array.length; index += 1) {
    /* eslint-disable no-await-in-loop */
    await callback(array[index], index, array);
  }
}

// can be used to set empty values to null before sending them to the hub.
export function setEmptyOrUndefinedToNull(obj: $TSFixMe) {
  if (!isObject(obj)) {
    return obj;
  }
  Object.keys(obj).forEach((key) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (obj[key] === "" || obj[key] === undefined) {
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      obj[key] = null;
    }
  });
  return obj;
}

export function snakeToCamel(value: $TSFixMe) {
  return value.replace(/_(\w)/g, (m: $TSFixMe) => m[1].toUpperCase());
}

export function formatNumberInText(value: $TSFixMe) {
  return value.replace(/([\d\.]+)/g, (m: $TSFixMe) =>
    formatNumber(parseFloat(m)),
  );
}

class NumberParser {
  decimal: $TSFixMe;

  /*
    Full implementation including arab etc.: https://observablehq.com/@mbostock/localized-number-parsing
  */
  constructor() {
    const parts = numberFormat().formatToParts(12345.6);
    this.decimal = new RegExp(
      `[${
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        parts.find((d) => d.type === "decimal").value
      }]`,
    );
  }

  parse(string: $TSFixMe) {
    if (!isSomething(string)) {
      return NaN;
    }
    return parseFloat(string.trim().replace(this.decimal, "."));
  }
}

export function parseIntlNumber(value: $TSFixMe) {
  return new NumberParser().parse(value);
}

export function isValidDecimalSeparator(value: $TSFixMe) {
  const parts = numberFormat().formatToParts(1.2);
  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const decimalSeparator = parts.find((d) => d.type === "decimal").value;
  let isValid = false;

  if (decimalSeparator === ".") {
    const dotTestComma = value
      .split("")
      .filter((c: $TSFixMe) => c === ",").length;
    const dotTestDot = value
      .split("")
      .filter((c: $TSFixMe) => c === decimalSeparator).length;
    isValid = dotTestComma === 0 && dotTestDot <= 1;
  } else {
    const commaTestComma = value
      .split("")
      .filter((c: $TSFixMe) => c === decimalSeparator).length;
    const commaTestDot = value
      .split("")
      .filter((c: $TSFixMe) => c === ".").length;
    isValid = commaTestDot === 0 && commaTestComma <= 1;
  }
  return isValid;
}

export function isValidFloat(value: $TSFixMe) {
  return /^-?\d+([\.\,]\d+)?$/.test(value);
}

export function arraysEqual(_arr1: $TSFixMe, _arr2: $TSFixMe) {
  if (
    !Array.isArray(_arr1) ||
    !Array.isArray(_arr2) ||
    _arr1.length !== _arr2.length
  )
    return false;

  const arr1 = _arr1.concat().sort();
  const arr2 = _arr2.concat().sort();

  for (let i = 0; i < arr1.length; i += 1) {
    if (arr1[i] !== arr2[i]) return false;
  }

  return true;
}
